const storageName = 'Vibix'

export const setDataToStorage = (subName:string = '', data:string) => {
    localStorage.setItem(`${storageName}_${subName}`, data);
}

export const getDataFromStorage = (subName: string = ''): string | null => {
    return localStorage.getItem(`${storageName}_${subName}`);
}

export const removeFromStorage = (subName:string = ''): void => {
    return localStorage.removeItem(`${storageName}_${subName}`);
}